import { FaSpinner } from "react-icons/fa";

export default function LoadingSpinner({ customColor, customBg }) {
  return (
    <div
      className="spinner-wrapper"
      style={{
        backgroundColor: customBg,
        color: customColor,
      }}
    >
      <FaSpinner className="spin" size={40} />
    </div>
  );
}
